import styled from 'styled-components';
import { fonts } from 'themes/default';
const { fontStyleRegular } = fonts;

const StyledErrorPage = styled.div`
  ${fontStyleRegular}
`;

export default StyledErrorPage;
